import { render, staticRenderFns } from "./BotonSmsCumple.vue?vue&type=template&id=36cd7d1d"
import script from "./BotonSmsCumple.vue?vue&type=script&lang=js"
export * from "./BotonSmsCumple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports